module.exports = __webpack_public_path__ + "static/media/user.a195ece2.svg";